export default __webpack_public_path__ + "static/media/etisalat.ce255fe0.png";